const colors = {
  primary: "var(--color-primary)",
  primaryAccent: "var(--color-primary-accent)",
  secondary: "var(--color-secondary)",
  secondaryAccent: "var(--color-secondary-accent)",
  background: "var(--color-background)",
  text: "var(--color-text)",
  textLight: "var(--color-text-light)",
  success: "var(--color-success)",
  error: "var(--color-error)",
  lightGray: "var(--color-light-gray)",
  buttonText: "var(--color-button-text)",
};

export default colors;
